'use client';

import { useState } from 'react';
import { useId } from 'react-aria';
import { useControlledComponent } from 'hooks/useControlledComponent';

type UseCollapseOptions = {
  isShowing?: boolean;
  id?: string;
  onRequestChange?: (isShowing: boolean) => void;
  defaultShowing?: boolean;
  monitorHeight?: boolean;
  disabled?: boolean;
};

export function useCollapse({
  isShowing: isShowingProp,
  onRequestChange,
  defaultShowing,
  monitorHeight = false,
  id,
  disabled,
}: UseCollapseOptions = {}) {
  const uid = useId(id);
  const [intentToAnimate, setIntentToAnimate] = useState(false);

  const [isShowing, setIsShowing] = useControlledComponent(
    isShowingProp,
    onRequestChange,
    defaultShowing
  );

  const triggerId = `${uid}-trigger`;

  const triggerEventHandlers = !disabled && {
    onMouseEnter: () => setIntentToAnimate(true),
    onMouseLeave: () => setIntentToAnimate(false),
    onClick:
      isShowingProp != null && !onRequestChange
        ? undefined
        : () => setIsShowing(!isShowing),
  };

  return {
    isShowing,
    id: uid,
    monitorHeight,
    intentToAnimate,
    bindTrigger: {
      type: 'button',
      id: triggerId,
      'aria-controls': uid,
      'aria-expanded': isShowing,
      'aria-disabled': disabled,
      ...triggerEventHandlers,
    },
    bindCollapse: {
      id: uid,
      'aria-labelledby': triggerId,
      role: 'region',
    },
  };
}
